import { render } from "./addEditApp.vue?vue&type=template&id=70bb3951"
import script from "./addEditApp.vue?vue&type=script&lang=js"
export * from "./addEditApp.vue?vue&type=script&lang=js"

import "./addEditApp.vue?vue&type=style&index=0&id=70bb3951&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__